import * as React from 'react';

import {Carousel} from 'antd';
import {Form, Formik} from 'formik';

import {List} from '@common/typescript/objects/List';

import SimpleMap from '@app/components/UI/SimpleMap/SimpleMap';

import '@app/scss/components/vetsMap.scss';

import '@app/scss/components/findVet.scss';
import {Veterinarian} from '@app/objects/Veterinarian';
import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import {rest} from '@app/components/Api';
import {StatesListItem} from '@app/objects/StatesListItem';
import {ListOption} from '@app/objects/SidebarProps';

const avatarPlaceholder = require('@app/content/dog.png');
const arrowIcon = require('@app/images/arrow_circle.svg');
const arrowIconHovered = require('@app/images/button_slider.svg');

interface VetsMapProps {
	veterinarians: Veterinarian[];
	stateName: string;
	setStateName: (arg: string) => void;
	setVetsCount: (arg: number) => void;
}

const VetsMap: React.FC<VetsMapProps> = ({veterinarians, stateName, setStateName, setVetsCount}) => {
	const slider = React.useRef<any>();
	const [cardsLoading, setCardsLoading] = React.useState(false);
	const [stateList, setStateList] = React.useState<StatesListItem[]>([]);
	const [activeStateItem, setActiveStateItem] = React.useState<string>();
	const stateListOptions: ListOption[] = [];

	const transformStateList = () => {
		stateList && stateList.map((item, index) => {
			stateListOptions.push({value: item.name});
		});
	};

	React.useEffect(() => {
		setCardsLoading(false);
	}, [veterinarians]);

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states')
			.then((res) => {
				setStateList(res.list);
			});
	}, []);

	transformStateList();
	return (
		<div className="vets-map">
			<div className="vets-map-wrapper">
				<div className="vets-map-body">
					<h2>A passionate network of <span className="highlight">nationwide</span> veterinarians</h2>

					<Formik
						onSubmit={(values) => {
							console.log(values);
						}}
						initialValues={{state: ''}}

						render={(formikBag) => {
							return (
								<>
								<Form
									className="vets-map__state-form"
								>
									<SearchFieldAuto
										name="state"
										placeholder= "Select a state"
										listOptions={stateListOptions}
										formikBag={formikBag}
										onSelect = {(value, option) => {
											formikBag.setFieldValue('state', value);
											setStateName(value);
											setCardsLoading(true);
											setActiveStateItem(value);
										}}
										onChange={(value) => {
											formikBag.setFieldValue('state', value);
											!value && 
											setStateName('');
											setCardsLoading(true);
											setActiveStateItem('');
										}}
										searchButton={false}
										allowClear={true}
									/>
								</Form>

								<div className="vets-map-body__container">
									<SimpleMap<StatesListItem>
										onClick={(currentState) => {
											
											if (currentState.veterinarians > 0) {
												console.log(currentState, 'CURRENT_STATE');
												currentState.veterinarians ? setActiveStateItem(currentState.name) : null;
												setCardsLoading && setCardsLoading(true);
												setStateName && setStateName(currentState.name);
												setVetsCount && setVetsCount(30);
												formikBag.setFieldValue('state', currentState.name);
											} else {
												null;
											}
										}}
										states={stateList}
										getFillColor={state => activeStateItem === state.name
											? '#9c8cae'
											: state.veterinarians > 0
												? '#bdb0cb'
												: '#d5cce0'
										}
										getTooltip={state => `${state.veterinarians} local vets`}
									/>
								</div>
								<div className="vets-map-body__tag">
									<img src={require('@app/images/pin_circle.svg')} alt="pin"/>
									<span>Viewing {stateName ? stateName : 'all'} Vets</span>
								</div>
							</>
							);
						}}
					/>
					
					<div className="vets-map-carousel">
						{
							veterinarians.length > 4 &&
							<div className="slider-buttons">
								<div className="slider-button_left__wrapper">
									<img
										className="slider-button slider-button_left"
										src={arrowIcon}
										alt="Prev"
										onClick={() => slider.current!.prev()}
									/>
									<img
										className="slider-button slider-button_left_hovered"
										src={arrowIconHovered}
										alt="Prev"
										onClick={() => slider.current!.prev()}
									/>
								</div>
							</div>	
							
						}
						
						{
							cardsLoading ? 'Loading...' :
							<Carousel
								ref={slider}
								slidesToShow={ veterinarians.length < 5 ? veterinarians.length : 1}
								// afterChange={setCurrentIndex}
								dots={false}
								infinite
								variableWidth={true}
								responsive={[
									{
										breakpoint: 768,
										settings: {
											slidesToShow: 1,
										}
									}
								]}
							>
								{veterinarians.map((item: Veterinarian, index) => {
									return (
										<div
											className="vets-map-carousel__item"
											key={item.id}
										>
											<div className="vets-map-carousel__item-avatar">
												<img src={item.avatar ? item.avatar : avatarPlaceholder} alt={'veterinarian'} className="slider-vet-item"/>
											</div>
											<div className="vets-map-carousel__item-descr">
												<h3>Dr.{' '}{item.firstName}</h3>
												<p>{item.areaName}</p>
											</div>
										</div>

									);
								})}
							</Carousel>
						}
					</div>
				</div>

			</div>
		</div>
	);
};

export default VetsMap;